export const NAV_LINKS = [
  { id: '1', href: '#funkcje', title: 'FUNKCJE' },
  { id: '2', href: '#cennik', title: 'CENNIK' },
  {
    id: '3',
    href: '/app/?path=login',
    title: 'ZALOGUJ',
  },
]
